module.exports = __webpack_public_path__ + "static/media/mm.a210c6ba.svg";